/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 25.05.2016
 *
 */

import { RemoteDataActions } from 'plugin/liferay-widgets-react-web';
import ClassNames from '../constants/ClassNames';
import LayerDataSourceWebApi from '../webapi/LayerDataSourceWebApi';

const className = ClassNames.LayerDataSource;

export default {

    list: (name, query) => RemoteDataActions.list(name, className, query),
    listByMapConfig: (name, query) => RemoteDataActions.list(name, className, query, LayerDataSourceWebApi.listByMapConfig),
    item: (name, query) => RemoteDataActions.item(name, className, query),

    moreItems: (name, query) => RemoteDataActions.moreItems(name, className, query)
};



// WEBPACK FOOTER //
// ./js/actions/LayerDataSourceActions.js